import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "doubleQuotes",
  "use": "doubleQuotes-usage",
  "viewBox": "0 0 41 37",
  "content": "<symbol viewBox=\"0 0 41 37\" xmlns=\"http://www.w3.org/2000/svg\" id=\"doubleQuotes\"><text fill=\"#fff\" fill-rule=\"evenodd\" font-family=\"ArialMT, Arial\" font-size=\"158\" transform=\"translate(-6 -28)\"><tspan x=\"0\" y=\"143\">“</tspan></text></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/svgs/doubleQuotes.svg
// module id = 390
// module chunks = 0